import React from 'react';
import { Tag } from 'antd';
import { stageMeta } from 'assets/data/estadosPresupuesto';
import { hallazgoEtapaMeta } from 'assets/data/cicloMeta';

/**
 * Chip compacto y consistente de la etapa del ciclo. Centraliza el lookup
 * etapa→meta para que las vistas no rendericen Tags sueltos con lógica repetida.
 *  - kind="budget" (default): usa `stageMeta` (8 etapas compuestas presupuesto+ODT).
 *  - kind="hallazgo": usa `hallazgoEtapaMeta` (6 etapas del hallazgo).
 * Reusa el `Tag` de antd (mismo look que los listados ya tenían) — no introduce
 * un estilo nuevo ni duplica `BudgetBadge`.
 */
function EtapaChip({ stage, kind = 'budget' }) {
  const meta = kind === 'hallazgo' ? hallazgoEtapaMeta[stage] : stageMeta[stage];
  if (!meta) return <Tag>{stage ?? '—'}</Tag>;
  return <Tag color={meta.color ?? 'default'}>{meta.label ?? meta.description ?? stage}</Tag>;
}

export default EtapaChip;
